import React, { ChangeEvent, FormEvent } from "react";
import { Prompt, RouteComponentProps } from "react-router";
import { V2 } from "../../Api";

import withTitle from "../withTitle";

interface IMessagingNumberAddViewState {
    isSubmitting: boolean | string;
    hasChanged: boolean;

    number: string;
    name: string;
}

interface IMessagingNumberAddViewProps extends RouteComponentProps<any> {

}

class MessagingNumberAddView extends React.Component<IMessagingNumberAddViewProps, IMessagingNumberAddViewState> {
    constructor(props: Readonly<IMessagingNumberAddViewProps>) {
        super(props);

        const state: IMessagingNumberAddViewState = {
            isSubmitting: false,
            hasChanged: false,

            number: "",
            name: "",
        };

        this.state = state;

        this.formInputChanged = this.formInputChanged.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.cancelForm = this.cancelForm.bind(this);
    }

    public render() {
        return (
            <div className="viewer-root">
                <Prompt when={this.state.hasChanged} message="Your changes will not be saved if you continue." />
                <form className="input-form" onSubmit={this.submitForm}>
                    <div className="column-root">
                        <section className="info-block">
                            <header>
                                <h3>Number Info</h3>
                            </header>

                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-number">Number</label>
                                    <input type="text" id="frm-number" name="number" value={this.state.number} onChange={this.formInputChanged} />
                                </div>
                                <div className="input-form-group">
                                    <label htmlFor="frm-number-name">Name</label>
                                    <input type="text" id="frm-number-name" name="name" value={this.state.name} onChange={this.formInputChanged} />
                                </div>
                            </section>
                        </section>
                        <section />
                    </div>
                    &nbsp;
                    {this.state.isSubmitting === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.isSubmitting === "string"
                            ? <div className="error-text">{this.state.isSubmitting}</div>
                            : null}
                    <div className="action-panel">
                        <button type="submit" className="button text-with-icon push-right"><i className="icon-check" /><span>Save</span></button>
                        <button type="button" className="button text-with-icon" onClick={this.cancelForm}><i className="icon-times" /><span>Cancel</span></button>
                    </div>
                </form>
            </div>
        );
    }

    private formInputChanged(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            hasChanged: true,
            [name]: value
        } as any);
    }

    private async submitForm(e: FormEvent) {
        e.preventDefault();

        try {
            this.setState({
                isSubmitting: true
            });

            if (!this.state.number.match(/\+1\d{10}/)) {
                this.setState({
                    isSubmitting: "The entered phone number is not in the correct format. Must be in E.164 format (e.g. +18775551234)"
                });
                return;
            }

            if (!this.state.name) {
                this.setState({
                    isSubmitting: "A name must be entered"
                });
                return;
            }

            const data = {
                number: this.state.number,
                name: this.state.name,
            };

            await V2.post("messaging/numbers", data);

            this.setState({
                hasChanged: false,
                isSubmitting: false
            }, () => this.cancelForm());
        }
        catch (e) {
            this.setState({
                isSubmitting: e.message || "Could not submit"
            });
        }
    }

    private cancelForm() {
        this.props.history.goBack();
    }
}

export default withTitle("Add Phone Number", MessagingNumberAddView);
